/* eslint-disable no-unused-expressions */
import React, {useContext, useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";
import {
    ErrorMessage,
    ErrorMessageDoc,
    InputLabel,
    InputWrapper,
    ReservationFormWrapper,
    Row,
    Subtitle,
    Title
} from "./styles";
import {useTranslation} from "react-i18next";
import {Login} from "../Login";
import {InputField, Select, TextArea, Checkbox} from "../../../../components/common";
import {useDispatch, useSelector} from "react-redux";
import {
    selectForceLogin, selectHullType, selectReservationDetails,
    selectVesselBeam,
    selectVesselDraft,
    selectVesselLength, selectVesselType, selectVesselsSameDimensions, selectIsNewVessel,
    selectVessel,
    selectIsLoggedInStep1,
    selectVesselPhoto,
    selectVesselInsurance,
    selectVesselLicense,
    selectSkiperId
} from "../../../../store/slices/reservation/selectors";
import {reservationActions} from "../../../../store/slices/reservation/reservationSlice";
import countries, {countries as countryData} from "../../../../utils/countries";
import {VesselType, HullType, NatureOfTravel} from "../../../../settings/enums";
import {selectMarina, selectMarinas} from "../../../../store/slices/app/selectors";
import {AuthContext} from "../../../../context/AuthProvider";
import Document from 'components/Document/DocumentWithFormik';
import { docTypes } from "container/Agent/Reservation/ReservationPage";
import HomeMarinaSelect from "container/SinglePage/Reservation/homeMarinaSelect";
import { generateID } from "library/helpers/utils";

const ReservationForm = props => {
    const {formik, requirements, additionalRequirements, focusOnFirst, setFocusOnFirst, submitted, refreshData} = props;
    const { user: boater } = useContext(AuthContext);
    const {t} = useTranslation();
    const marina = useSelector(selectMarina);
    const marinas = useSelector(selectMarinas);
    const length = useSelector(selectVesselLength);
    const beam = useSelector(selectVesselBeam);
    const draft = useSelector(selectVesselDraft);
    const vesselType = useSelector(selectVesselType);
    const hullType = useSelector(selectHullType);
    const forceLogin = useSelector(selectForceLogin);
    const reservationDetails = useSelector(selectReservationDetails);
    const vessels = useSelector(selectVesselsSameDimensions);
    const isNewVessel = useSelector(selectIsNewVessel);
    const dispatch = useDispatch();
    const selectedVessel = useSelector(selectVessel);
    const isLoggedInStep1 = useSelector(selectIsLoggedInStep1);

    const firstNameRef = useRef (null);
    const lastNameRef = useRef (null);
    const emailRef = useRef (null);
    const emailConfirmRef = useRef (null);
    const phoneRef = useRef (null);
    const addressRef = useRef (null);
    const postCodeRef = useRef (null);
    const countryRef = useRef (null);
    const vesselNameRef = useRef (null);
    const vesselTypeRef = useRef (null);
    const vesselRef = useRef (null);
    const hullTypeRef = useRef (null);
    const homeMarinaRef = useRef (null);
    const notRef = useRef (null);

    const [vessel_license, set_vessel_license] = useState(null)
    const [vessel_photo, set_vessel_photo] = useState(null)
    const [vessel_insurance, set_vessel_insurance] = useState(null)
    const [skiper_id, set_skiper_id] = useState(null)

    const [flagType, setFlagType] = useState(true)
    const [flaghullType, setFlagHullType] = useState(true)
    const [flagHomeMarina, setFlagHomeMarina] = useState(true)

      
    //clean all unnecessary things
    useEffect(() => {
        if(focusOnFirst) {
            if (formik.errors.firstName) {
                firstNameRef.current?.focus();
            } else if (formik.errors.lastName) {
                lastNameRef.current?.focus();
            } else if (formik.errors.mail) {
                emailRef.current?.focus();
            } else if (formik.errors.mailConfirmation) {
                emailConfirmRef.current?.focus();
            } else if (formik.errors.phoneNumber) {
                phoneRef.current?.focus();
            } else if (formik.errors.address) {
                addressRef.current?.focus();
            } else if (formik.errors.postCode) {
                postCodeRef.current?.focus();
            } else if (formik.errors.country) {
                countryRef.current?.focus();
            } else if (formik.errors.vesselName) {
                vesselNameRef.current?.focus();
            } else if (formik.errors.vesselType) {
                vesselTypeRef.current?.focus();
            } else if (formik.errors.hullType) {
                hullTypeRef.current?.focus();
            } else if (formik.errors.homeMarinaId) {
                homeMarinaRef.current?.focus();
            } else if (formik.errors.natureOfTravel) {
                notRef.current?.focus();
            } else if (formik.errors.existingVesselName) {
                vesselRef.current?.focus();
            }
            setFocusOnFirst(false);
        }
    }, [formik.errors, focusOnFirst]);

    useEffect(() => {
        if (boater && !forceLogin && !reservationDetails) {
            if (boater.first_name?.length > 0) {
                formik.setFieldValue('firstName', boater.first_name);
                setTimeout(() => formik.setFieldTouched('firstName', true));
            }
            if (boater.last_name?.length > 0) {
                formik.setFieldValue('lastName', boater.last_name);
                setTimeout(() => formik.setFieldTouched('lastName', true));
            }
            if (boater.email?.length > 0) {
                formik.setFieldValue('mail', boater.email);
                formik.setFieldValue('mailConfirmation', boater.email);
                setTimeout(() => formik.setFieldTouched('mail', true));
                setTimeout(() => formik.setFieldTouched('mailConfirmation', true));
            }
            if(boater.phone?.length > 0) {
                formik.setFieldValue('phoneNumber', boater.phone);
                setTimeout(() => formik.setFieldTouched('phoneNumber', true));
            }
            if(boater.address?.length > 0) {
                formik.setFieldValue('address', boater.address);
                setTimeout(() => formik.setFieldTouched('address', true));
            }
            if(boater.address_line_two?.length > 0) {
                formik.setFieldValue('addressLineTwo', boater.address_line_two);
                setTimeout(() => formik.setFieldTouched('addressLineTwo', true));
            }
            if(boater.country_of_residence?.length > 0) {
                const country = countryData.find(country => country.code === boater.country_of_residence);
                if(country) {
                    formik.setFieldValue('country', country.name);
                    setTimeout(() => formik.setFieldTouched('country', true));
                }
            }
            if((boater.postal_code?.length || 0) > 0) {
                formik.setFieldValue('postCode', boater.postal_code);
                setTimeout(() => formik.setFieldTouched('postCode', true));
            }
            
            setTimeout(() => formik.validateForm())
        }
    }, [boater, forceLogin, reservationDetails]);

    useEffect(() => {
        if (boater && !forceLogin && !reservationDetails && !isLoggedInStep1) {
            const vessels = boater.vessels?.filter(vessel =>
                parseFloat(vessel.length) === parseFloat(`${length}`) &&
                parseFloat(vessel.beam) === parseFloat(`${beam}`) &&
                parseFloat(vessel.draft) === parseFloat(`${draft}`) &&
                (vessel.home_marina_name!==marina?.name) &&
                (requirements?.vesselType ? vesselType === vessel.type : true) &&
                (requirements?.hullType ? hullType === vessel.hull_type : true)
            );
            dispatch(reservationActions.setVesselsSameDimensions(vessels))
            // if (vessels?.length) {
            //     dispatch(reservationActions.setIsNewVessel(false))
            // }
            if (vessels?.length === 0) {
                dispatch(reservationActions.setVessel(undefined))
                dispatch(reservationActions.setIsNewVessel(true))//redundant
            }
        }
    }, [boater, requirements, length, beam, draft, forceLogin, reservationDetails]);

    useEffect(()=>{

        if(!selectedVessel){
            return;
        }
        dispatch(reservationActions.setvesselInsuranceFile(undefined));
        dispatch(reservationActions.setvesselLicenseFile(undefined));
        dispatch(reservationActions.setvesselPhotoFile(undefined));
        set_vessel_license(null);
        set_vessel_insurance(null);
        set_vessel_photo(null);

        const vesselAttachments = selectedVessel? selectedVessel.attachments :[];
        
           let vesselLicense = vesselAttachments.filter(
            a => a.attachment_type === docTypes.vessel_license
          )[0];
           let vesselInsurance = vesselAttachments.filter(
            a => a.attachment_type === docTypes.vessel_insurance
          )[0];
           
           let vesselPhoto = vesselAttachments.filter(
            a => a.attachment_type === docTypes.vessel_photo
          )[0];
          if(vesselInsurance){
            set_vessel_insurance(vesselInsurance);
            formik.setFieldValue('vessel_insurance', vesselInsurance)
          }
          if(vesselLicense){
            set_vessel_license(vesselLicense);
            formik.setFieldValue('vessel_license', vesselLicense)
          }
          
          if(vesselPhoto){ 
            set_vessel_photo(vesselPhoto);
            formik.setFieldValue('vessel_photo', vesselPhoto)
          }
          formik.setFieldValue('homeMarinaId', selectedVessel?.home_marina_id? selectedVessel.home_marina_id 
            : selectedVessel?.home_marina_name? generateID(selectedVessel.home_marina_name) : undefined )
    
        },[selectedVessel])

        useEffect(()=>{
            const boaterAttachments = boater? boater.attachments :[];
            let skiperId = boaterAttachments.filter(
                a => a.attachment_type === docTypes.skipper_id
              )[0];
              if(skiperId){
                set_skiper_id(skiperId);
                dispatch(reservationActions.setskiperIdFile(undefined));
                formik.setFieldValue('skipper_id', skiperId);
              }
        },[boater])



    const onFirstNameChange = name => {
        formik.setFieldValue('firstName', name);
        dispatch(reservationActions.setFirstName(name));
    }
    const onLastNameChange = name => {
        formik.setFieldValue('lastName', name);
        dispatch(reservationActions.setLastName(name));
    }
    const onPhoneNumberChange = num => {
        formik.setFieldValue('phoneNumber', num);
        dispatch(reservationActions.setPhone(num));
    }
    const onEmailChange = mail => {
        formik.setFieldValue('mail', mail);
        dispatch(reservationActions.setMail(mail.toLowerCase()));
    }
    const onEmailConfirmationChange = mail => formik.setFieldValue('mailConfirmation', mail);


    const onAddressChange = address => {
        formik.setFieldValue('address', address);
        dispatch(reservationActions.setAddress(address));
    }
    const onAddressLineTwoChange = address => {
        formik.setFieldValue('addressLineTwo', address);
        dispatch(reservationActions.setAddressLineTwo(address));
    }

    const onPostCodeChange = postCode => {
        formik.setFieldValue('postCode', postCode);
        dispatch(reservationActions.setPostCode(postCode));
    }

    const onCountryChange = country => {
        formik.setFieldValue('country', country);
        dispatch(reservationActions.setCountry(country));
    }

    const onVesselSelect = vesselName => {
        setFlagHullType(true)
        setFlagType(true)
        setFlagHomeMarina(true)

        if (vesselName === 'newBoat') {
            formik.setValues({
                ...formik.values,
                existingVesselName: vesselName,
                vesselName: '',
                vessel_photo:undefined,
                vessel_license:undefined,
                vessel_insurance:undefined,
                homeMarinaId:undefined
            })
            dispatch(reservationActions.setIsNewVessel(true))
            dispatch(reservationActions.setVessel(undefined))
            dispatch(reservationActions.setVesselName(undefined))
            dispatch(reservationActions.setvesselInsuranceFile(undefined));
            dispatch(reservationActions.setvesselLicenseFile(undefined));
            dispatch(reservationActions.setvesselPhotoFile(undefined));
            set_vessel_license(null);
            set_vessel_insurance(null);
            set_vessel_photo(null);

        } else {

            const selectedVessel = vessels?.find((v) => v.name === vesselName)
            formik.setValues({
                ...formik.values,
                existingVesselName: vesselName,
                vesselName: vesselName,
                vesselType: selectedVessel?.type,
                hullType: selectedVessel?.hull_type,
                homeMarinaId: undefined
            })
            if (selectedVessel?.type === null) {
                setFlagType(false)
            }
            if (selectedVessel?.hull_type === null) {
                setFlagHullType(false)
            }
            if (selectedVessel?.home_marina_name === null) {
                setFlagHomeMarina(false)
            }

            dispatch(reservationActions.setIsNewVessel(false))
            dispatch(reservationActions.setVessel(selectedVessel))
            dispatch(reservationActions.setVesselName(selectedVessel?.name))
        }

    }

    const onVesselTypeChange = type => {
        formik.setFieldValue('vesselType', type);
        dispatch(reservationActions.setVesselType(type));
    }

    const onHullTypeChange = type => {
        formik.setFieldValue('hullType', type);
        dispatch(reservationActions.setHullType(type));
    }

    const onWaterElectricityChanged = needed => {
        formik.setFieldValue('waterElectricity', needed);
        dispatch(reservationActions.setNeedWaterElectricity(needed));
    }

    const onLiveaboardChanged = needed => {
        formik.setFieldValue('liveAboard', needed);
        dispatch(reservationActions.setLiveaboard(needed));
    }

    const onVesselNameChange = name => {
        formik.setFieldValue('vesselName', name);
        dispatch(reservationActions.setVesselName(name));
    }

    const onNatureOfTravelChange = natureOfTravel => {
        formik.setFieldValue('natureOfTravel', natureOfTravel);
        dispatch(reservationActions.setNatureOfTravel(natureOfTravel));
    }

    const onPowerChange = power => {
        formik.setFieldValue('power', power);
        // dispatch(reservationActions.setNotes(power || undefined));
    }
    const onNotesChange = notes => {
        formik.setFieldValue('notes', notes);
        dispatch(reservationActions.setNotes(notes || undefined));
    }

    const renderInput = (
        label,
        key,
        ref,
        onChange,
        type,
        disabled
    ) => (
        <InputWrapper>
            <InputLabel>{t(label)}</InputLabel>
            <InputField inputRef={ref} error={submitted && !!formik.errors[key]} value={formik.values[key] || ''}
                        onChange={onChange} type={type || 'text'} disabled={disabled}/>
            {submitted && formik.errors[key] && <ErrorMessage>{formik.errors[key]}</ErrorMessage>}
        </InputWrapper>);

    const renderSelect = (
        label,
        hint,
        ref,
        key,
        onChange,
        options,
        disabled
    ) => (<InputWrapper>
        <InputLabel>{t(label)}</InputLabel>
        <Select
            inputRef={ref}
            value={formik.values[key]}
            options={options}
            onChange={onChange}
            error={submitted && !!formik.errors[key]}
            hint={t(hint)}
            disabled={disabled} />
        {submitted && formik.errors[key] && <ErrorMessage>{formik.errors[key]}</ErrorMessage>}
    </InputWrapper>);

    return (<ReservationFormWrapper>
        <Title>{t('COMPLETE_YOUR_INFORMATION')}</Title>
        <Login/>
        <Subtitle>{t('PERSONAL_DETAILS')}</Subtitle>
        <Row>
            {renderInput('FIRST_NAME', 'firstName', firstNameRef, onFirstNameChange)}
            {renderInput('LAST_NAME', 'lastName', lastNameRef, onLastNameChange)}
        </Row>
        <Row>
            {renderInput('EMAIL', 'mail', emailRef, onEmailChange, 'email')}
            {renderInput('CONFIRM_EMAIL', 'mailConfirmation', emailConfirmRef, onEmailConfirmationChange, 'email')}
        </Row>
        {additionalRequirements?.phone && <Row>
            {renderInput('PHONE_NUMBER_INCL', 'phoneNumber', phoneRef, onPhoneNumberChange, 'tel')}
        </Row>}
        {additionalRequirements?.address && <Row>
            {renderInput('ADDRESS', 'address', addressRef, onAddressChange)}
        </Row>}
        {additionalRequirements?.address && <Row>
            {renderInput('ADDRESS_LINE_2', 'addressLineTwo', null, onAddressLineTwoChange)}
        </Row>}
        {additionalRequirements?.postCode && <Row>
            {renderInput('POST_CODE', 'postCode', postCodeRef, onPostCodeChange)}
        </Row>}
        {additionalRequirements?.country && <Row>
            {renderSelect('COUNTRY', 'SELECT_COUNTRY', countryRef, 'country', onCountryChange, countries)}
        </Row>}
        {additionalRequirements?.skipper_id && <Row>
            <Document
                  label={t('SKIPPER_ID_LICENSE')}
                  type='SKIPPER_ID_LICENSE'
                  name='skipper_id'
                  file={formik.values.skipper_id}
                  onChange={value => {
                    //   refreshData({ parameters: ['attachments'] });
                      dispatch(reservationActions.setskiperIdFile(value))
                  }}
                  onRemove={()=>{
                    // refreshData({ parameters: ['attachments'] });
                  }}
                  marinaName={marina.name}
                  vessel_id={selectedVessel?.id}
                  formik={formik}
                  disabled={ !!skiper_id }
                />
                {submitted && formik.errors['skipper_id'] && <ErrorMessageDoc >{formik.errors['skipper_id']}</ErrorMessageDoc>}
          
        </Row>}
        <Subtitle>{t('BOAT_DETAILS')}</Subtitle>

        {(( !!boater && !!vessels?.length) && !isLoggedInStep1) && <Row>
            {renderSelect('BOAT', 'SELECT_BOAT', vesselRef, 'existingVesselName', onVesselSelect,
                [
                    ...(vessels?.map(item => ({ label: item.name, value: item.name })) || []),
                    { label: '+ Add new boat...', value: 'newBoat', isNewOption: true }
                ]
            )}
        </Row>}

       { !(boater && !isNewVessel && !isLoggedInStep1) && <Row> {renderInput('BOAT_NAME', 'vesselName', vesselNameRef, onVesselNameChange, null, !!boater && !isNewVessel)} </Row>}

        {additionalRequirements?.vesselType && <Row>
            {renderSelect('BOAT_TYPE', 'SELECT_BOAT_TYPE', vesselTypeRef, 'vesselType',
                onVesselTypeChange, Object.keys(VesselType).map(opt => ({ label: t(opt), value: opt })), (!isNewVessel && selectedVessel.type))}
        </Row>}
        {additionalRequirements?.hullType && <Row>
            {renderSelect('HULL_TYPE', 'SELECT_HULL_TYPE',  hullTypeRef, 'hullType',
                onHullTypeChange, Object.keys(HullType).map(opt => ({ label: t(opt), value: opt })), (!isNewVessel && selectedVessel.hull_type))}
        </Row>}
        
        {additionalRequirements?.homeMarina && <Row>
            <InputWrapper>
                <HomeMarinaSelect
                    formik={formik}
                    selectedVessel={selectedVessel}
                    submitted={submitted}
                /> 
                {submitted && formik.errors.homeMarinaId && <ErrorMessage>{formik.errors.homeMarinaId}</ErrorMessage>}
            </InputWrapper></Row>}
        {additionalRequirements?.natureOfTravel && <Row>
            {renderSelect('NATURE_OF_TRAVEL', 'SELECT_NATURE_OF_TRAVEL', notRef,'natureOfTravel',
                onNatureOfTravelChange, Object.keys(NatureOfTravel).map(opt => ({label: t(opt), value: opt})))}
        </Row>}
        {additionalRequirements?.vessel_license && <Row>
            <Document
                  label={t('VESSEL_LICENSE')}
                  type='VESSEL_LICENSE'
                  name='vessel_license'
                  file={formik.values.vessel_license}
                  onChange={value => {
    
                    //   refreshData({ parameters: ['vessels'] });
                      dispatch(reservationActions.setvesselLicenseFile(value))
                    
                  }}
                  onRemove={()=>{
                    // refreshData({ parameters: ['vessels'] });
                  }}
                  marinaName={marina.name}
                  vessel_id={selectedVessel?.id}
                  formik={formik}
                  disabled={ !!vessel_license}
                  
                />
                {submitted && formik.errors['vessel_license'] && <ErrorMessageDoc >{formik.errors['vessel_license']}</ErrorMessageDoc>}
          
        </Row>}
        
        {additionalRequirements?.vessel_photo && <Row style={{alignItems: 'center'}}>
        
            <Document
                  label={t('VESSEL_PHOTO')}
                  type='VESSEL_PHOTO'
                  name='vessel_photo'
                  file={formik.values.vessel_photo}
                  onChange={value => {
                    // refreshData({ parameters: ['vessels'] });
                    dispatch(reservationActions.setvesselPhotoFile(value))
                  }}
                  onRemove={()=>{
                    // refreshData({ parameters: ['vessels'] });
                  }}
                  marinaName={marina.name}
                  vessel_id={selectedVessel?.id}
                  formik={formik}
                  disabled={ !!vessel_photo}
                />
            {submitted && formik.errors['vessel_photo'] && <ErrorMessageDoc >{formik.errors['vessel_photo']}</ErrorMessageDoc>}
     
        </Row>}
        {additionalRequirements?.vessel_insurance && <Row>
            <Document
                  label={t('VESSEL_INSURANCE')}
                  type='VESSEL_INSURANCE'
                  name='vessel_insurance'
                  file={formik.values.vessel_insurance}
                  onChange={value => {
    
                    //   refreshData({ parameters: ['vessels'] });
                      dispatch(reservationActions.setvesselInsuranceFile(value))
                    
                  }}
                  onRemove={()=>{
                    // refreshData({ parameters: ['vessels'] });
                  }}
                  marinaName={marina.name}
                  vessel_id={selectedVessel?.id}
                  formik={formik}
                  disabled={!!vessel_insurance}
                  
                />
                {submitted && formik.errors['vessel_insurance'] && <ErrorMessageDoc >{formik.errors['vessel_insurance']}</ErrorMessageDoc>}
          
        </Row>}
        {additionalRequirements?.waterElectricity && <Row><Checkbox
            label={t('NEED_WATER_AND_ELECTRICITY')}
            checked={formik.values.waterElectricity}
            onCheckedChanged={onWaterElectricityChanged}/></Row>}

        {additionalRequirements?.liveAboard && <Row><Checkbox
        label={"Liveaboard (live onboard)"}
        checked={formik.values.liveAboard}
        onCheckedChanged={onLiveaboardChanged}/></Row>}
        <Row>
            <InputWrapper>
                <InputLabel>{t('SPECIAL_INQUIRIES_OR_REQUESTS')}</InputLabel>
                <TextArea maxLength={500} onChange={onNotesChange}/>
                {submitted && formik.errors.notes && <ErrorMessage>{formik.errors.notes}</ErrorMessage>}
            </InputWrapper>
        </Row>

    </ReservationFormWrapper>);
}

ReservationForm.propTypes = {
    formik: PropTypes.object,
    requirements: PropTypes.object,
    additionalRequirements: PropTypes.object,
    focusOnFirst: PropTypes.bool,
    submitted: PropTypes.bool,
    setFocusOnFirst: PropTypes.func,
}

export default ReservationForm;
